import React from "react";
import { Crown } from "lucide-react";
import API from "../api/axiosConfig";
import { toast } from "react-toastify";

export default function AssignOwner({ companyId, users, onAssigned }) {
  const handleAssign = async (userId) => {
    try {
      const res = await API.patch(`/companies/${companyId}/assign-owner`, {
        userId,
      });

      toast.success("Owner asignado correctamente 👑");

      onAssigned(res.data);
    } catch (err) {
      toast.error("Error asignando owner");
    }
  };

  return (
    <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-xl">
      <h3 className="font-semibold text-yellow-800 mb-2 flex items-center gap-2">
        <Crown size={18} /> Empresa sin owner
      </h3>

      <p className="text-sm text-yellow-700 mb-3">
        Selecciona un usuario para asignarlo como owner de la empresa.
      </p>

      <div className="flex flex-col gap-2">
        {users.map((u) => (
          <button
            key={u._id}
            onClick={() => handleAssign(u._id)}
            className="flex justify-between items-center bg-white hover:bg-yellow-100 border px-3 py-2 rounded-lg text-sm transition"
          >
            <span>
              {u.name} — {u.email}
            </span>
            <span className="text-xs text-yellow-700 font-semibold">
              Asignar
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
